const formatDate = () => {
  const now = new Date();
  const days = ["SUNDAY", "MONDAY", "TUESDAY", "WEDNESDAY", "THURSDAY", "FRIDAY", "SATURDAY"];
  const months = ["JANUARY", "FEBRUARY", "MARCH", "APRIL", "MAY", "JUNE", "JULY", "AUGUST", "SEPTEMBER", "OCTOBER", "NOVEMBER", "DECEMBER"];

  const dayName = days[now.getDay()];
  const monthName = months[now.getMonth()];
  const day = now.getDate();
  const year = now.getFullYear();

  return `${dayName} - ${monthName} ${day}, ${year}`;
};

export function Masthead() {
  return (
    <header className="masthead">
      <div className="container">
        <div className="masthead-meta">
          <span>{formatDate()}</span>
          <span>&#9733; &#9733; &#9733;</span>
          <span>DIGIS.IO</span>
        </div>
        <div className="wordmark">digis<span className="amp">.</span>io</div>
        <div className="masthead-tagline">- Plainspoken accounting for people who'd rather be doing literally anything else -</div>
      </div>
    </header>
  );
}
